module.exports = __webpack_public_path__ + "bc44aab7a3a195da2096b5139946db71.svg";